import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

import { useMutation, useQuery } from '@apollo/client';
import { singleOrderQuery } from '../../graphql/queries';
import Spinner from '../../components/LoadingSpinner';
import { OrderPre } from './styled';
import OrderHistory from './OrderHistory';
import { updateOrderStatusMutation } from '../../graphql/mutations';
import { orderCanceledStates } from '@/utils/order';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import {
  CanAccessBills,
  ViewerContext,
} from '../../providers/ViewerContextProvider';
import { FaLock } from 'react-icons/fa';
import { OrderBill } from './OrderBill';
import { OrderOverview } from './OrderOverview';
import ScrollToTop from '@/utils/scrollToTop';
import i18n from '@/utils/i18n';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

export default function AdminOrder({
  match: {
    params: { orderId },
  },
}) {
  useDocumentTitle('PageTitles:preOrder', orderId);

  const [updateOrderStatus, { loading: updatingOrderStatus }] = useMutation(
    updateOrderStatusMutation,
  );
  const [selectedCancelState, setSelectedCancelState] = useState(
    orderCanceledStates[0],
  );

  const viewer = useContext(ViewerContext);
  const allowedToAccess = CanAccessBills(viewer);

  const { data = { order: null }, loading } = useQuery(singleOrderQuery, {
    variables: { order_id: orderId },
    fetchPolicy: 'network-only',
  });

  function cancelOrder() {
    if (!window.confirm('Are you sure you want to cancel this order?')) {
      return;
    }

    updateOrderStatus({
      variables: {
        order_id: orderId,
        status: selectedCancelState,
      },
      refetchQueries: [
        {
          query: singleOrderQuery,
          variables: {
            order_id: orderId,
          },
        },
      ],
    });
  }

  const order = data.order;

  return (
    <div className="p-3">
      <ScrollToTop />{' '}
      {order && (
        <h4>
          <b>
            {order.external_id !== null ? `${i18n.t('Order:external')} ` : ''}
          </b>
          {`${i18n.t('Order:order')} ${order.readable_id || ''} - ${i18n.t(
            'Order:pickupCode',
          )} ${order.code_text || ''}`}
        </h4>
      )}
      {loading && <Spinner />}
      <br />
      {order && (
        <OrderOverview order={order} allowedToAccess={allowedToAccess} />
      )}
      <br />
      {order && <OrderBill order={order} isAdmin={allowedToAccess} />}
      {order && <OrderHistory order={order} />}
      {allowedToAccess && (
        <>
          <br />
          <br />
          <br />
          <br />
          <hr />
          <h4>
            <FaLock /> Admin-only area
          </h4>
          <br />
          <FormGroup>
            <Label for="order-state-select">Cancel Order</Label>
            <Input
              type="select"
              name="select"
              id="order-state-select"
              onChange={(e) => setSelectedCancelState(e.target.value)}
            >
              {orderCanceledStates.map((state) => (
                <option value={state}>{state}</option>
              ))}
            </Input>
          </FormGroup>
          <FormGroup>
            <Button
              color="danger"
              onClick={cancelOrder}
              disabled={updatingOrderStatus || loading}
            >
              Cancel Order
            </Button>
          </FormGroup>

          <OrderPre>
            {order &&
              JSON.stringify(
                order,
                (key, value) => (key === '__typename' ? undefined : value),
                ' ',
              )}
          </OrderPre>
        </>
      )}
    </div>
  );
}
AdminOrder.propTypes = {
  match: PropTypes.object.isRequired,
};
